import {Component, inject, OnInit} from '@angular/core';
// import {AuthUserProfile} from "../../store/entities/uaa/auth-user.model";
import {StorageService} from "../../services/storage.service";

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
  standalone: false
})
export class UserProfileComponent implements OnInit {
  viewUpdate: boolean;
  storageService = inject(StorageService);
  authUser: any;

  constructor() {
  }

  ngOnInit(): void {
    this.authUser = this.storageService.get('userProfile');

  }


}
